export default "__VITE_ASSET__Dx5dPV1D__"